import { addProductionInformationV2 } from '@reducers/manufacture';

import { LINK_STATUS } from '@helpers';
import type { RunLinkNcFileToJobParams, LinkNcFileResult } from '@components/search/operations/components/StartJobPopup/types';

// Links the machine's currently-selected NC file + batch to this job; success/failure arrive over SignalR
// (OnAddedProductionInformation / OnFailedToChangeProductionInformation), surfaced via addProductionInformationV2.
export const runLinkNcFileToJob = async ({ dispatch, ncFileId, productionOperationId, productionBatchId, setLinkStatus, setLinkError, onLinked }: RunLinkNcFileToJobParams) => {
  setLinkStatus(LINK_STATUS.Linking);
  setLinkError(undefined);

  const { error, errorDetails } = (await dispatch(addProductionInformationV2({ ncFileId, productionOperationId, productionBatchId }))) as LinkNcFileResult;

  if (error) {
    setLinkStatus(LINK_STATUS.Error);
    // A timeout rejects with a bare string and carries no message — fall back to the generic copy in resolveLinkStatusContent.
    setLinkError(typeof errorDetails === 'string' ? undefined : errorDetails?.errorMessage);
    return;
  }

  setLinkStatus(LINK_STATUS.Linked);
  onLinked?.(ncFileId);
};
